import { render, staticRenderFns } from "./SwitchOrdersConcept.vue?vue&type=template&id=3e2445b0"
import script from "./SwitchOrdersConcept.vue?vue&type=script&lang=js"
export * from "./SwitchOrdersConcept.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrdersConcept.vue?vue&type=style&index=0&id=3e2445b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports